import { useTranslation } from 'react-i18next'

// import { ReactSVG } from "react-svg";
import { useMyBonusTotalQuery } from '@shared/generated'
import Wrapper from '@shared/ui/wrapper'

import { Card } from './Card'
import { Savings } from './Savings'
// import { Cashback } from "./Сashback";

import styles from './styles.module.scss'

export default function PersonalBonus () {
  const { t: tn } = useTranslation('personal')
  const { data: { myBonus } = {} } = useMyBonusTotalQuery()

  // номер активной карты
  const activeCardNumber = myBonus?.bonusCards?.find(
    (card) => card?.status === 'active',
  )?.cardNumber

  // сумма бонусов в статусе "в ожидании"
  const pendingBonusesAmount = myBonus?.pendingBonuses?.reduce(
    (sum, item) => sum + (item?.amount || 0),
    0,
  )

  const bonusExpireAt = myBonus?.nearestExpiringBonus
    ? new Date(myBonus.nearestExpiringBonus.expireAt).toLocaleDateString(
      'ru-RU',
      {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
      },
    )
    : null

  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <div className={styles.root__content}>
          <h2 className={styles.root__title}> {tn('nav.loyalty')}</h2>
          <Card
            balance={myBonus?.activeBonuses}
            cardNumber={activeCardNumber}
            pendingBonusesAmount={pendingBonusesAmount}
            bonusExpireAmount={myBonus?.nearestExpiringBonus?.expireAmount}
            bonusExpireAt={bonusExpireAt}
            className={styles.root__container}
          />
          {/* <Cashback className={styles.root__container} /> */}{' '}
          {/* //временно скрыли и поправил grid в стилях */}
          <Savings className={styles.root__container} />
          {/* <div className={styles.root__trash}>
            <ReactSVG src="/icons/trash.svg" />
            <span>{tn("bonus.delete")}</span>
          </div> */}
          {/* //временно скрыли */}
        </div>
      </Wrapper>
    </div>
  )
}
